import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../Context/LanguageContext';
import { useMemberData } from '../hooks/useMemberData';
import useCountUp from '../hooks/useCountUp';

// Use Google Sheets data (same as MembersMap)
const USE_GOOGLE_SHEETS = true;

const Hakkimizda = (props) => {
    const { t } = useLanguage();
    const { totalMembers, totalCountries, loading } = useMemberData(USE_GOOGLE_SHEETS);

    const [membersRef, membersDisplay] = useCountUp(loading ? 0 : totalMembers, 1800, '+');
    const [countriesRef, countriesDisplay] = useCountUp(loading ? 0 : totalCountries, 1400, '');

    let vizyon = "";
    let amaclar = [];
    let kimler = [];

    if (props.data) {
        vizyon = props.data.vizyon;
        amaclar = props.data.accordion[0].points;
        kimler = props.data.accordion[1].points;
    }

    // Animation variants for staggered reveals
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15,
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 25 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, ease: 'easeOut' }
        }
    };

    return (
        <section id="hakkimizda">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-50px" }}
                    transition={{ duration: 0.5 }}
                >
                    <h2>{t('about.vision')}</h2>
                    <blockquote>
                        <p>{vizyon}</p>
                    </blockquote>
                </motion.div>

                <motion.div
                    className="about-grid"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                >
                    <motion.div className="about-card" variants={itemVariants}>
                        <h3>{t('about.aims')}</h3>
                        <ul>
                            {amaclar && amaclar.map((point, i) => <li key={i}>{point}</li>)}
                        </ul>
                    </motion.div>
                    <motion.div className="about-card" variants={itemVariants}>
                        <h3>{t('about.whoCanJoin')}</h3>
                        <ul>
                            {kimler && kimler.map((point, i) => <li key={i}>{point}</li>)}
                        </ul>
                    </motion.div>
                </motion.div>

                <div className="stats-grid">
                    <motion.div
                        className="stat-box"
                        ref={membersRef}
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, type: "spring", stiffness: 150 }}
                    >
                        <span className="stat-number">{loading ? '...' : membersDisplay}</span>
                        <span className="stat-label">{t('map.stats.members')}</span>
                    </motion.div>
                    <motion.div
                        className="stat-box"
                        ref={countriesRef}
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.1, type: "spring", stiffness: 150 }}
                    >
                        <span className="stat-number">{loading ? '...' : countriesDisplay}</span>
                        <span className="stat-label">{t('map.stats.countries')}</span>
                    </motion.div>
                </div>

                <motion.div
                    className="download-section"
                    initial={{ opacity: 0, y: 15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4 }}
                >
                    <a href="https://docs.google.com/spreadsheets/d/1uHOnTichAmPiwvVsGU9LXGurxgxFtXgFpuM3FET9nIw/edit?usp=sharing" target="_blank" rel="noopener noreferrer" className="button">
                        <i className="fa fa-lock" aria-hidden="true" style={{marginRight: '10px'}}></i> {t('common.memberList')}
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default Hakkimizda;
